// PaymentGateway
import { axiosApiInstance } from "../App";
import { url } from "./url.service";

const serverUrl = url + "/newsLetter";

export const add = (formData) => {
  console.log(formData, "inaxios");
  return axiosApiInstance.post(serverUrl + "/", formData);
};

export const get = (query) => {
  return axiosApiInstance.get(`${serverUrl}/`);
};
// console.log(getPaymentGateway, "get in axiso43");
export const deleteById = (id) => {
  return axiosApiInstance.delete(`${serverUrl}/deleteById/${id}`);
};

export const update = (formData, id) => {
  console.log(formData, "formData", id, "id in aiso ");
  return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, formData);
};
